import {
	getController,
	type HpRequestOptional,
	apiService as Service,
} from '@/services/service'

const url = 'users'

export const usersService = {
	...getController<Api.User, Api.UserPostInput, Api.UserUpdatePost>(url),
	show: (id: number, data?: HpRequestOptional) =>
		Service.get<Api.User>({
			url: `${url}/${id}?rel=["persons", "latest_login"]`,
			...data,
		}),
	attachToDatabase: ({
		account,
		client,
	}: {
		account: number
		client: number
	}) => Service.post({ url: `${url}/${account}/databases/${client}` }),
	accountDatabasePut: ({
		account,
		client,
		data,
	}: {
		account: number
		client: number
		data: HpRequestOptional
	}) =>
		Service.put({
			url: `${url}/${account}/databases/${client}`,
			data,
		}),
	adminGet: ({ client_id }: { client_id: number }) =>
		Service.get({
			url: `${url}?rel=["persons"]&q[]=clientaccount.is_admin&v[]=1&q[]=clientaccount.client_database_id&v[]=${client_id}&sm=1`,
		}),
	itemImageGet: (id: number) => {
		return Service.get<ArrayBuffer>({
			url: `${url}/${id}/profileimage`,
			responseType: 'arraybuffer',
		})
	},
	search: (value: string, field = 'email') =>
		Service.get({ url: `${url}/?q[]=${field}&v[]=${value}` }),
	itemImagePost: ({ id, data }: { id: number; data: HpRequestOptional }) => {
		return Service.post({ url: `${url}/${id}`, ...data })
	},
}

export default usersService
